// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../node_modules/@vue/cli-service/node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".empty[data-v-517c3ecc] {\n  color: #8e9cbb;\n}\n.field-form__type[data-v-517c3ecc] .c-select__group-label {\n  color: black;\n  font-weight: 400;\n}\n[data-v-517c3ecc] .used {\n  font-size: 11px;\n}\n", ""]);
// Exports
module.exports = exports;
